import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { HardDrive } from 'lucide-react';

export default function DiskUsageChartSkeleton() {
    return (
        <div className="oct_sys-chart-card-v2">
            <div className="oct_sys-chart-header-v2 mb-4">
                <HardDrive className="oct_icon" />
                <h3>Disk Usage</h3>
            </div>

            <div className="oct_sys-mem-stats-list-v2 gap-2">
                {[...Array(5)].map((_, i) => (
                    <div className="stat-row" key={i}>
                        <Skeleton variant="text" width="30%" />
                        <Skeleton variant="text" width="40%" />
                    </div>
                ))}
            </div>

            <div className="oct_sys-chart-pie-wrapper-v2 mt-2 oct_skeleton-chart-h100">
                <div className="oct_sys-chart-pie-center-v2">
                    <Skeleton variant="circular" width={90} height={90} />
                </div>
                <div className="oct_sys-chart-pie-center-v2">
                    <Skeleton variant="circular" width={60} height={60} className="oct_skeleton-bg-white" />
                </div>
            </div>

            <div className="oct_chart-legend-v2">
                <div className="legend-item">
                    <Skeleton variant="rectangular" width={12} height={12} className="color-box" />
                    <Skeleton variant="text" width={30} />
                </div>
                <div className="legend-item">
                    <Skeleton variant="rectangular" width={12} height={12} className="color-box" />
                    <Skeleton variant="text" width={30} />
                </div>
            </div>
        </div>
    );
}
